export default __webpack_public_path__ + "static/media/category1.c079ce85.png";